import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import { DepartmentSelectorService } from './app-content-wrapper/department-selector/department-selector.service';
import { Department } from './app-content-wrapper/department-selector/department-selector.component';

@Injectable()
export class AppCurrentDepartmentResolver implements Resolve<Department | null> {
  constructor(private departmentSelectorService: DepartmentSelectorService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Department | null> {
    const departmentIdParam = route.params.department_id;
    const departmentId = departmentIdParam ? parseInt(departmentIdParam, 10) : NaN;

    if (!departmentIdParam || isNaN(departmentId)) {
      return of(null);
    }

    return this.departmentSelectorService.allDepartments$.pipe(
      first(),
      map((departments) => {
        const department = departments.find((dep) => dep.id === departmentId);
        return department || null;
      }),
      catchError(() => of(null))
    );
  }
}
